// extracted by mini-css-extract-plugin
module.exports = {"figcaption":"full-width-image_figcaption__odvm7","figure":"full-width-image_figure__yBfCT"};